/*!
 * Sem Costura — prefetch-nav
 * Fallback universal para browsers sem Speculation Rules (Safari/Firefox):
 * - hover >=80ms  → <link rel=prefetch as=document>
 * - card no viewport (mobile/touch) → mesmo prefetch
 * Dedup por URL, teto de 2 em voo e 6 por página, respeita Save-Data e 2g/slow-2g.
 * Não roda em Chromium quando document.prerendering/HTMLLinkElement suporta
 * "prerender" via speculationrules (mais forte já cobre).
 * Cobre também swatches de cor da PDP (.pdp__swatch[href]) e cards de kit
 * (.pdp__kit-list a[href]) via o listener genérico de hover/touch.
 */
(function () {
  if (typeof window === "undefined") return;

  // Save-Data / conexão lenta → desliga
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn) {
    if (conn.saveData) return;
    var et = String(conn.effectiveType || "");
    if (et === "slow-2g" || et === "2g") return;
  }

  // Se o browser suporta Speculation Rules, o próprio HTML já cuida —
  // este script vira no-op para não duplicar tráfego.
  if (HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")) {
    return;
  }

  var seen = new Set();
  var inflight = 0;
  var MAX = 2;
  var MAX_TOTAL = 6;
  var HOVER_DELAY = 80;
  var supportsLinkPrefetch = (function () {
    try {
      var l = document.createElement("link");
      return l.relList && l.relList.supports && l.relList.supports("prefetch");
    } catch (_) { return false; }
  })();

  function shouldSkip(href) {
    if (!href) return true;
    var lower = href.toLowerCase();
    if (lower.indexOf("/cart") === 0) return true;
    if (lower.indexOf("/checkout") === 0) return true;
    if (lower.indexOf("/account") === 0) return true;
    if (lower.indexOf("#") === 0) return true;
    if (lower.indexOf("mailto:") === 0) return true;
    if (lower.indexOf("tel:") === 0) return true;
    return false;
  }

  function normalize(a) {
    try {
      var raw = a.getAttribute("href") || "";
      if (shouldSkip(raw)) return null;
      var u = new URL(a.href, window.location.href);
      if (u.origin !== window.location.origin) return null;
      if (u.pathname === window.location.pathname && u.search === window.location.search) return null;
      if (shouldSkip(u.pathname)) return null;
      if (a.hasAttribute("data-no-prefetch")) return null;
      if (a.closest("[data-no-prefetch]")) return null;
      return u.pathname + u.search;
    } catch (_) { return null; }
  }

  function hasModifier(e) {
    return !!(e && (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey));
  }

  function prefetch(url) {
    if (seen.has(url) || inflight >= MAX || seen.size >= MAX_TOTAL) return;
    seen.add(url);
    inflight++;
    var done = function () { inflight = Math.max(0, inflight - 1); };
    if (supportsLinkPrefetch) {
      var link = document.createElement("link");
      link.rel = "prefetch";
      link.as = "document";
      link.href = url;
      link.onload = link.onerror = done;
      document.head.appendChild(link);
    } else {
      // Safari não suporta <link rel=prefetch>; usa fetch discreto.
      try {
        fetch(url, { credentials: "same-origin", priority: "low" })
          .then(done, done);
      } catch (_) { done(); }
    }
  }

  // Hover intent (desktop)
  var hoverTimer = 0;
  document.addEventListener("mouseover", function (e) {
    if (hasModifier(e)) return;
    var a = e.target && e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    var url = normalize(a);
    if (!url) return;
    if (hoverTimer) clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(url); }, HOVER_DELAY);
  }, { passive: true });
  document.addEventListener("mouseout", function () {
    if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = 0; }
  }, { passive: true });
  // Touch: prefetch no touchstart (intenção mais forte que hover)
  document.addEventListener("touchstart", function (e) {
    if (hasModifier(e)) return;
    var a = e.target && e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    var url = normalize(a);
    if (url) prefetch(url);
  }, { passive: true, capture: true });

  // Viewport: cards de produto/coleção
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var a = entry.target;
        io.unobserve(a);
        var url = normalize(a);
        if (url) prefetch(url);
      });
    }, { rootMargin: "200px" });

    var observeCards = function () {
      document.querySelectorAll(".product-card a[href], .tile a[href], .subcollection-card a[href]").forEach(function (a) {
        if (a.__prefetchObserved) return;
        a.__prefetchObserved = true;
        io.observe(a);
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeCards);
    } else {
      observeCards();
    }
    // Re-observa após swaps AJAX (filtros/paginação)
    document.addEventListener("collection:updated", observeCards);
    var mo = new MutationObserver(function () { observeCards(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();